import React from 'react';
import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';

// react-apexcharts IIFE build expects a global React (see apexcharts/react-apexcharts#642)
window.React = React;

// ==============================|| REACT DOM RENDER  ||============================== //

console.log(
  `%c Version: {{BUILD_PACKAGE_VERSION}}, Image Tag: {{BUILD_IMAGE_TAG}}, Branch Name: {{BUILD_BRANCH_NAME}}`, 
  "color: #2296F3; font-weight: bold; font-size: 12px; padding: 4px;"
);

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
